import { ButtonProps } from '@mui/material';
import { ComponentsOverrides, Theme } from '@mui/material/styles';

export default function MuiButton(theme: Theme): {
  MuiButton: { defaultProps: ButtonProps; styleOverrides: ComponentsOverrides<Theme>['MuiButton'] };
} {
  return {
    MuiButton: {
      defaultProps: {
        variant: 'contained',
        disableElevation: true,
        disableRipple: true,
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
        // Sizes
        sizeLarge: {
          height: '48px',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '24px',
          padding: '12px 24px',
        },
        sizeMedium: {
          height: '40px',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: '24px',
          padding: '8px 16px',
        },
        sizeSmall: {
          height: '32px',
          fontSize: '14px',
          fontWeight: 500,
          lineHeight: '20px',
          padding: '6px 16px',
        },
        // Contained variant
        containedPrimary: {
          backgroundColor: theme.palette.primary.main,
          color: theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
          '&:disabled': {
            background: theme.palette.grey[400],
            color: theme.palette.common.white,
          },
        },
        containedSecondary: {
          backgroundColor: theme.palette.primary.light,
          color: theme.palette.common.white,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
          '&:disabled': {
            background: theme.palette.grey[400],
            color: theme.palette.common.white,
          },
        },
        // Text variant
        textPrimary: {
          color: theme.palette.primary.main,
          disabled: {
            color: theme.palette.common.white,
          },
          '&:hover': {
            color: theme.palette.primary.dark,
          },
        },
        // Outlined variant
        outlinedPrimary: {
          color: theme.palette.primary.main,
          '&:hover': {
            color: theme.palette.primary.dark,
          },
          '&:disabled': {
            color: theme.palette.grey[400],
          },
        },
        outlinedSecondary: {
          color: theme.palette.primary.light,
          borderColor: theme.palette.primary.light,
          '&:hover': {
            color: theme.palette.primary.dark,
            borderColor: theme.palette.primary.dark,
          },
          '&:disabled': {
            color: theme.palette.grey[400],
            borderColor: theme.palette.primary.dark,
          },
        },
      },
    },
  };
}
